module.exports = __webpack_public_path__ + "img/77.2.TN.1f448c0d.png";